
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'widget-responses',
})
export default class WidgetResponses extends Vue {
  @Prop({required: true}) readonly vacancy;

  

  get responses() {
    const list = this.$store.getters['responses/filteredList'];
    if (!list || !list.length) {
      return [];
    }

    return list.filter(item => !item.is_hidden)
  };

  get count() {
    return this.responses.length;
  };
  
  get responsesFiltered() {
    const count = this.count <= 6 ? 6 : 5;
    return this.responses.filter((item, index) => index < count);
  };

  public go_to_responses() {
    this.$store.commit('responses/updateFilters', {data: {
      vacancy: this.vacancy
    }});
    this.$router.push({name: 'responses'})
  };

  destroyed() {
    this.$store.commit('responses/clearFilter');
  };
}
